import { RealtimeProvider } from '@utils/providers/realtime-context.tsx';
import { RealtimeWorkspace } from '@components/editors/realtime-editor/realtime-workspace.tsx';
import { RealtimeEditorProvider } from '@utils/providers/realtime-editor-context.tsx';
import { Navigate, useParams } from 'react-router-dom';
import { liveEditorPath } from '@utils/api/realtime/live-transcript.ts';

export default function RealtimeEditor() {
  const { sessionId } = useParams();
  if (sessionId) return <Navigate to={liveEditorPath(sessionId)} replace />;
  return (
    <RealtimeProvider>
      <RealtimeEditorProvider>
        <RealtimeWorkspace />
      </RealtimeEditorProvider>
    </RealtimeProvider>
  );
}
